module.exports = __webpack_public_path__ + "img/csi-page-tabs-image-4.8b3c0ae2.jpg";